/**
 * Paleta y helpers para la LÍNEA DE NEGOCIO. Se mapean por nombre porque
 * el modelo `Business` del backend no expone color todavía; si algún día
 * lo hace, preferimos ese. Fallback en gris para negocios no mapeados
 * (evita chips sin color cuando cambian los datos).
 */
const BUSINESS_DOT = {
  "vision travel": "#31D0E1",
  safeguard: "#1A2436",
  "real vision": "#EC7137",
  visionbiz: "#31D0E1",
};

export const businessDotColor = (name = "") =>
  BUSINESS_DOT[String(name).trim().toLowerCase()] ||
  "var(--color-line-strong)";

/** Devuelve el nombre de la LÍNEA DE NEGOCIO de un curso (Vision Travel,
 *  Safeguard, …), NO el nombre de la categoría/nivel.
 *
 *  Prioridad: `course.business.name` (campo directo añadido en
 *  apiacademy migración 001 — fuente de verdad); fallback a la ruta por
 *  categoría para cursos aún no backfilled o endpoints viejos que no
 *  exponen `business`. Si tampoco está, null y el llamador oculta el
 *  chip. Antes se caía a `category.name`, pero eso pintaba
 *  "Introductorio" donde el diseño espera el nombre del negocio. */
export const courseBusinessName = (course) =>
  course?.business?.name ??
  course?.categoryCourse?.category?.categoryBusiness?.business?.name ??
  null;
